import { render, staticRenderFns } from "./create-edit.vue?vue&type=template&id=a25dbd26&scoped=true"
import script from "./create-edit.vue?vue&type=script&lang=js"
export * from "./create-edit.vue?vue&type=script&lang=js"
import style0 from "./create-edit.vue?vue&type=style&index=0&id=a25dbd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25dbd26",
  null
  
)

export default component.exports